module.exports = __webpack_public_path__ + "img/selection-product.7246b6f6.webp";